@for (field of field.fieldGroup; track field; let index = $index; let last = $last) {
  <div [ngClass]="{ 'mb-4': !last }" class="flex-column p-4 traveler-card">
    <div
      tabindex="0"
      (click)="toggle(index)"
      (keydown)="onHeaderKeydown($event, index)"
      class="d-flex justify-content-between align-items-start cursor-pointer card-header"
      data-id="traveler-card-header"
    >
      <div class="flex-column pr-3">
        @let labels = field.props?.['labels'] || props['labels'];
        @if (labels && labels[index]) {
          <h3 class="bold text-travalign-main" data-id="label">{{ labels[index] }}</h3>
        }

        @if (!isExpanded(index)) {
          @let summary = getSummary(index);

          <p
            class="mt-1"
            [class.text-travalign-main]="!summary.isError"
            [class.text-red-600]="summary.isError"
            data-id="traveler-summary"
          >
            {{ summary.text }}
            @if (summary.actionText) {
              · <span class="text-red-600">{{ summary.actionText }}</span>
            }
          </p>
        }
      </div>

      <ds-button
        variant="icon"
        [icon]="isExpanded(index) ? 'chevronUp' : 'chevronDown'"
        [label]="isExpanded(index) ? 'Collapse traveler' : 'Expand traveler'"
        (click)="$event.stopPropagation(); toggle(index)"
        data-id="traveler-card-toggle"
      />
    </div>

    <div
      [id]="'traveler-card-body-' + index"
      [attr.hidden]="isExpanded(index) ? null : true"
      [ngClass]="{ 'mt-4': isExpanded(index) }"
      class="w-100 card-body"
    >
      <formly-field [field]="field" class="w-100" />
    </div>
  </div>
}
